import React from 'react';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import { selectLocation } from 'store/Router/selectors';
import { useSelector } from 'react-redux';
import Searcher from 'Common/Components/Searcher';
import WorkspaceSelector from './WorkspaceMenuSelector';
import ThemeToggle from './ThemeToggle';
import ProcessingQueueButton from './ProcessingQueueButton';
import { Header, Separator, Wrapper } from './styled';
import VulnsCounter from './VulnsCounter';
import AssetSelector from './AssetSelector';
import Title from './Title';
import HomeButton from './HomeButton';
import HostModalCreate from '../HostModalCreate';

const NavMenuContext = () => {
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const location = useSelector((state) => selectLocation(state));
  const isInsideWs = location.pathname.startsWith('/feed') ||
   location.pathname.startsWith('/host/') ||
   location.pathname.startsWith('/manage') ||
   location.pathname.startsWith('/service/') ||
   location.pathname.startsWith('/credentials');
  const isOutsideWs = location.pathname.startsWith('/workspaces') ||
  location.pathname.startsWith('/vulnerabilities') ||
  location.pathname.startsWith('/hosts') ||
  location.pathname.startsWith('/services');

  const customPadding = location.pathname === '/automation/agents';

  return loggedIn && (
    <Header customPadding={ customPadding }>
      <Title />
      { isInsideWs &&
        <>
          <HomeButton />
          <Separator />
          <WorkspaceSelector />
        </>
      }
      <AssetSelector />
      <VulnsCounter />
      <Searcher />
      <HostModalCreate />
      <Wrapper isOutsideWs={ isOutsideWs }>
        <ThemeToggle />
        <ProcessingQueueButton />
      </Wrapper>
    </Header>
  );
};

export default NavMenuContext;
